'use strict';

var defaultOptions = {
  baseUrl: '/userservice/',
};

function get() {
  return defaultOptions;
}

function update(key, value) {
  defaultOptions[key] = value;
}

exports.get = get;
exports.update = update;
